/* eslint-disable space-before-function-paren */
/* eslint-disable padded-blocks */
/* eslint-disable no-trailing-spaces */

class Slideshow {
    constructor (el) {
        this.el = el || {}

        this.autoplay = true
        this.container = this.el.querySelector('.slideshowHero__inner')
        this.currentSlide = 1
        this.jumpLinks = el.querySelectorAll('[data-jumpto-slide]')
        this.segmint = {}
        this.slides = el.querySelectorAll('[data-slideshow-slide]')

        this.speed = el.getAttribute('data-slideshow-speed') * 1000 || 7000
        this.timer = 0
        this.pausedTime = 0
        this.totalSlides = this.slides.length / 3
        this.trigger = el.querySelector('[data-slideshow-autoplay]')
        this.jumpLinks.forEach((navDot) => {
            const slideId = navDot.getAttribute('data-jumpto-slide')
            navDot.addEventListener('click', () => {
                this.handleSlideChange(slideId, true)
            })
        })
        console.log('About to build segmint')

        this.buildSegmint = this.buildSegmint.bind(this)
        this.goToNextSlide = this.goToNextSlide.bind(this)
        this.handleNavDotChange = this.handleNavDotChange.bind(this)
        this.handleSlideChange = this.handleSlideChange.bind(this)
        this.pauseOnHover = this.pauseOnHover.bind(this)
        this.playOnHover = this.playOnHover.bind(this)
        this.runTimer = this.runTimer.bind(this)
        this.toggleAutoplay = this.toggleAutoplay.bind(this)
        this.waitForEl = this.waitForEl.bind(this)

        this.init()
    }

    waitForEl(selector) {
        return new Promise(resolve => {
            if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector))
            }

            const observer = new MutationObserver(mutations => {
                if (document.querySelector(selector)) {
                    resolve(document.querySelector(selector))
                    observer.disconnect()
                }
            })

            observer.observe(document.body, {
                childList: true,
                subtree: true,
            })
        })
    }

    pauseOnHover() {
        this.pausedTime = this.timer
        clearInterval(this.timer)
    }

    playOnHover(e) {
        if (!this.el.contains(e.relatedTarget) && this.autoplay === true) {
            this.timer = setInterval(this.goToNextSlide, this.speed - this.pausedTime)
            this.pausedTime = 0
        }
    }

    toggleAutoplay() {
        const playSvg = this.el.querySelector('#metro-play')
        const pauseSvg = this.el.querySelector('#metro-pause')

        if (this.autoplay === true) {
            this.autoplay = false
            clearInterval(this.timer)
            this.trigger.setAttribute('data-slideshow-autoplay', 'false')
            playSvg.style.display = 'block'
            playSvg.setAttribute('aria-hidden', 'false')
            pauseSvg.style.display = 'none'
            pauseSvg.setAttribute('aria-hidden', 'true')
        } else {
            this.autoplay = true
            this.runTimer()
            this.trigger.setAttribute('data-slideshow-autoplay', 'true')
            playSvg.style.display = 'none'
            playSvg.setAttribute('aria-hidden', 'true')
            pauseSvg.style.display = 'block'
            pauseSvg.setAttribute('aria-hidden', 'false')
        }
    }

    handleNavDotChange(slide) {
        const targetDots = this.el.querySelectorAll(`[data-jumpto-slide="${slide}"]`)

        this.jumpLinks.forEach((navDot) => {
            navDot.removeAttribute('data-active')
        })

        targetDots.forEach((targetDot) => {
            targetDot.setAttribute('data-active', 'true')
        })
    }

    handleSlideChange(slide, clear = false) {
        this.slides.forEach((slide) => {
            slide.removeAttribute('data-active')
            slide.setAttribute('aria-hidden', 'true')
            slide.style.display = 'none'
        })

        const targetSlides = this.el.querySelectorAll(
            `[data-slideshow-slide="${slide}"]`
        )

        targetSlides.forEach((targetSlide) => {
            targetSlide.setAttribute('data-active', 'true')
            targetSlide.setAttribute('aria-hidden', 'false')
            targetSlide.style.display = 'block'
        })

        this.handleNavDotChange(slide)
        this.runTimer(clear)
    }

    goToNextSlide() {
        let nextSlide = ++this.currentSlide

        if (nextSlide > this.totalSlides) {
            nextSlide = 1
            this.currentSlide = 1
        }
        this.handleSlideChange(nextSlide, true)
    }

    runTimer(clear) {
        if (clear) {
            clearInterval(this.timer)
        }

        if (this.autoplay === true) {
            this.timer = setInterval(this.goToNextSlide, this.speed)
        }
    }

    buildSegmint() {
        const contentContainer = this.el.querySelector('#segmint-content-container')
        if (!contentContainer) { return }

        this.waitForEl('#segmint-content').then(() => {

            this.segmint = {
                contentContainer: contentContainer,
                content: this.el.querySelector('#segmint-content'),
                fgContainer: this.el.querySelector('#segmint-fgImage-container'),
                fgImage: this.el.querySelector('#segmint-fgImage'),
            }
            this.segmint.fgContainer.innerHTML = this.segmint.fgImage.innerHTML
            this.segmint.fgImage.remove()
            this.segmint.contentContainer.innerHTML = this.segmint.content.innerHTML
            this.segmint.content.remove()

        })

    }

    init() {
        this.el.addEventListener('mouseover', this.pauseOnHover,)
        this.el.addEventListener('mouseout', this.playOnHover)
        this.trigger.addEventListener('click', this.toggleAutoplay)
        this.buildSegmint()
        this.runTimer()
    }
}

Array.from(document.querySelectorAll('[data-slideshow]')).forEach((el) => new Slideshow(el))
